export const environment = {
  production: true
};

export const SOCKET_SERVER = undefined;
export const API_ADDRESS = undefined;
